
import imgEmptyNhanVien from 'assets/images/img_emptyview_user.png';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import KTBSProgressBar from 'general/components/OtherKeenComponents/KTBSProgressBar';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
    KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import EmptyView from 'general/components/Others/EmptyView';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import RelatedOrderView from '../RelatedOrderView';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppConfigs from 'general/constants/AppConfigs';

SaleKPIListView.propTypes = {};

const defaultColumnIds = ['TIME', 'ACTUAL_SALES_GROUP', 'GROUP_ACTUAL', 'INVESTOR_ACTUAL', 'CHARGEPOINT_ACTUAL', 'COINVESTOR_ACTUAL', 'TOTAL_ACTUAL', 'GROUP_KPI', 'INVESTOR_KPI', 'CHARGEPOINT_KPI', 'COINVESTOR_KPI', 'TOTAL_KPI', 'KPI_PROGRESS', 'STATUS'];

function SaleKPIListView(props) {
    // MARK: ---- params ----
    const { t } = useTranslation();
    const router = useRouter();
    const { agencyDetail, getAgencyDetail, isSaleInfo = false } = props;
    const { user } = useSelector((state) => state.auth);
    const [saleKPITotal, setSaleKPITotal] = useState(0);
    const [saleKPIList, setSaleKPIList] = useState([]);
    const [filter, setFilter] = useState({
        agencyId: agencyDetail?.agencyId,
        page: 0,
        limit: AppConfigs.defaultPageLimit,
        month: '',
    });

    useEffect(() => {
        handleGetKPIList();
    }, [filter]);

    const handleGetKPIList = async () => {
        const res = await DealerHelper.callApiGetSaleKPIList(filter);
        const { saleKPIs } = res;
        setSaleKPIList(saleKPIs);
        const months = new Set(saleKPIs?.map(item => item.month));
        setSaleKPITotal(months.size);
    };

    const formatKPIDataForTable = (saleKPIs = []) => {
        const groupedByMonth = {};

        saleKPIs.forEach((item) => {
            const { month, orderType, kpiValue, actualValue } = item;

            if (!groupedByMonth[month]) {
                groupedByMonth[month] = {
                    key: month,
                    time: { month },
                    groupKPI: 0,
                    investorKPI: 0,
                    chargePointKPI: 0,
                    coinvestorKPI: 0,
                    groupActual: 0,
                    investorActual: 0,
                    chargePointActual: 0,
                    coinvestorActual: 0,
                    status: '',
                };
            }

            if (orderType === 'GROUP') {
                groupedByMonth[month].groupKPI = kpiValue || 0;
                groupedByMonth[month].groupActual = actualValue || 0;
            }

            if (orderType === 'INVESTOR') {
                groupedByMonth[month].investorKPI = kpiValue || 0;
                groupedByMonth[month].investorActual = actualValue || 0;
            }

            if (orderType === 'CHARGEPOINT') {
                groupedByMonth[month].chargePointKPI = kpiValue || 0;
                groupedByMonth[month].chargePointActual = actualValue || 0;
            }

            if (orderType === 'COINVESTOR') {
                groupedByMonth[month].coinvestorKPI = kpiValue || 0;
                groupedByMonth[month].coinvestorActual = actualValue || 0;
            }
        });

        return Object.values(groupedByMonth).map((row) => {
            const totalKPI = row.investorKPI + row.coinvestorKPI;
            const totalActual = row.investorActual + row.coinvestorActual;
            const kpiProgress = DealerHelper.getKpiProgressPercent(totalActual, totalKPI);
            const status = kpiProgress < 100 ? 'NOT COMPLETED' : 'COMPLETED';

            return {
                ...row,
                totalKPI,
                totalActual,
                kpiProgress: {
                    kpi: kpiProgress,
                    totalActual: totalActual,
                    totalKPI: totalKPI,
                },
                status,
            };
        });
    };

    const formattedSaleKPIList = useMemo(() => {
        return formatKPIDataForTable(saleKPIList);
    }, [saleKPIList]);

    const fullColumns = useMemo(() => {
        return [
            {
                title: UIHelper.buildTableColumn('Thời gian'),
                dataIndex: 'time',
                key: 'time',
                width: 130,
                render: (value) => 'Tháng ' + Utils.formatDateTimeToString(value?.month, 'MM/YYYY') || '',
                sorter: false,
            },
            {
                title: UIHelper.buildTableColumn('Doanh số thực tế (VNĐ)'),
                key: 'actual_sales_group',
                children: [
                    // {
                    //     title: UIHelper.buildTableColumn('Bán gói đầu tư HTKD'),
                    //     dataIndex: 'groupActual',
                    //     key: 'groupActual',
                    //     width: 150,
                    //     align: 'right',
                    //     render: (value) => Utils.formatNumber(value ?? 0),
                    //     sorter: false,
                    // },
                    {
                        title: UIHelper.buildTableColumn('Bán nhượng quyền'),
                        dataIndex: 'investorActual',
                        key: 'investorActual',
                        width: 150,
                        align: 'right',
                        render: (value) => Utils.formatNumber(value ?? 0),
                        sorter: false,
                    },
                    // {
                    //     title: UIHelper.buildTableColumn('Bán trụ sạc'),
                    //     dataIndex: 'chargePointActual',
                    //     key: 'chargePointActual',
                    //     width: 150,
                    //     align: 'right',
                    //     render: (value) => Utils.formatNumber(value ?? 0),
                    //     sorter: false,
                    // },
                    {
                        title: UIHelper.buildTableColumn('Bán liên kết'),
                        dataIndex: 'coinvestorActual',
                        key: 'coinvestorActual',
                        width: 150,
                        align: 'right',
                        render: (value) => Utils.formatNumber(value ?? 0),
                        sorter: false,
                    },
                ],
            },
            {
                title: UIHelper.buildTableColumn('Tổng doanh số thực tế', 'VNĐ'),
                dataIndex: 'totalActual',
                key: 'totalActual',
                width: 170,
                align: 'right',
                render: (value) => Utils.formatNumber(value ?? 0),
                sorter: false,
            },
            {
                title: UIHelper.buildTableColumn('KPI thiết lập (VNĐ)'),
                key: 'kpi_group',
                children: [
                    // {
                    //     title: UIHelper.buildTableColumn('Bán gói đầu tư HTKD'),
                    //     dataIndex: 'groupKPI',
                    //     key: 'groupKPI',
                    //     width: 170,
                    //     render: (value) => Utils.formatNumber(value ?? 0),
                    //     sorter: false,
                    //     align: 'right',
                    // },
                    {
                        title: UIHelper.buildTableColumn('Bán nhượng quyền'),
                        dataIndex: 'investorKPI',
                        key: 'investorKPI',
                        width: 180,
                        render: (value) => Utils.formatNumber(value ?? 0),
                        sorter: false,
                        align: 'right',
                    },
                    // {
                    //     title: UIHelper.buildTableColumn('Bán trụ sạc'),
                    //     dataIndex: 'chargePointKPI',
                    //     key: 'chargePointKPI',
                    //     width: 170,
                    //     render: (value) => Utils.formatNumber(value ?? 0),
                    //     sorter: false,
                    //     align: 'right',
                    // },
                    {
                        title: UIHelper.buildTableColumn('Bán liên kết'),
                        dataIndex: 'coinvestorKPI',
                        key: 'coinvestorKPI',
                        width: 170,
                        render: (value) => Utils.formatNumber(value ?? 0),
                        sorter: false,
                        align: 'right',
                    },
                ],
            },
            {
                title: UIHelper.buildTableColumn('Tổng mức KPI thiết lập', 'VNĐ'),
                dataIndex: 'totalKPI',
                key: 'totalKPI',
                width: 170,
                align: 'right',
                render: (value) => Utils.formatNumber(value ?? 0),
                sorter: false,
            },
            {
                title: UIHelper.buildTableColumn('Tiến độ KPI'),
                dataIndex: 'kpiProgress',
                key: 'kpiProgress',
                width: 170,
                align: 'left',
                render: (value) => (
                    <div className='w-100'>
                        <KTBSProgressBar
                            completed={value.kpi}
                            value={value.totalActual}
                            maxValue={value.totalKPI}
                            bgColor={AppColors.primary}
                            showValue={false}
                            width={120}
                        />
                    </div>
                ),
                sorter: false,
            },
            {
                title: UIHelper.buildTableColumn('Trạng thái'),
                dataIndex: 'status',
                key: 'status',
                width: 120,
                align: 'left',
                render: (value) => (
                    <KTLabel
                        text={value === 'COMPLETED' ? 'Hoàn thành' : 'Không đạt'}
                        isInline={true}
                        size={KTLabelSize.medium}
                        additionalClassName={`label-light-${value === 'COMPLETED' ? 'success' : 'danger'}`}
                    />
                ),
                sorter: false,
            },
            {
                title: UIHelper.buildTableColumn('Thao tác'),
                key: 'actions',
                width: 90,
                fixed: 'left',
                render: (_, record) => {
                    const currentMonth = moment().format('YYYY-MM');
                    const recordMonth = record?.time?.month;

                    return (
                        <div className="d-flex gap-2">
                            {!isSaleInfo && recordMonth === currentMonth && (
                                <KTTooltip offset={[0, 0]} text={'Chỉnh sửa'}>
                                    <a
                                        className="btn btn-sm btn-clean btn-icon"
                                        onClick={() => {
                                            DealerHelper.setMonthKPI(agencyDetail, () => {
                                                handleGetKPIList();
                                                getAgencyDetail(agencyDetail?.agencyId);
                                            });
                                        }}
                                    >
                                        <i
                                            className="fa-regular fa-edit"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        />
                                    </a>
                                </KTTooltip>
                            )}

                            <KTTooltip offset={[0, 0]} text={'Đơn hàng liên quan'}>
                                <a
                                    className="btn btn-sm btn-clean btn-icon"
                                    onClick={() => {
                                        AppCustomDialogHelper.show(
                                            'Đơn hàng liên quan',
                                            <RelatedOrderView
                                                item={record}
                                                agencyDetail={agencyDetail}
                                                onCancel={() => AppCustomDialogHelper.hide()}
                                            />,
                                            'xl',
                                            false,
                                            true
                                        );
                                    }}
                                >
                                    <i
                                        className="fa-regular fa-memo-circle-info"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    />
                                </a>
                            </KTTooltip>
                        </div>
                    );
                },
            }

        ];
    }, [t, formattedSaleKPIList, agencyDetail, isSaleInfo]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = `${router.pathname}${router.location.hash}`;
        return `${userId}_${pathName}`;
    }, [user, router]);

    const [fullColumnIds, setFullColumnIds] = useState(fullColumns?.map((row) => row?.id).filter(Boolean));

    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        resetDefaultTableColumn,
        saveChanges,
        onSelectAll,
        onUnSelectAll,
        fullColumnsIdSorted
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    const handleFilterChanged = (filter) => {
        if (onFilterChanged) {
            onFilterChanged(filter);
        }
    };

    // MARK: ---- methods ----

    return (
        <div>
            {/* header */}
            <div className="w-100 d-flex flex-row align-items-end flex-wrap justify-content-between">
                {/* loc theo khoang thoi gian */}
                <div className="col-lg-3 col-sm-6 px-0 pr-sm-4 p-0">
                    <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                        {t('Thời gian')}
                    </label>
                    <KTFormInput
                        name="month"
                        type={KTFormInputType.month}
                        onChange={(value) => {
                            setFilter({
                                ...filter,
                                month: value,
                            })
                        }}
                        value={filter.month}
                        placeholder='MM/YYYY'
                    />
                </div>
                {!isSaleInfo && (
                    <div>
                        {
                            UIHelper.buildGreenButton(
                                'Thiết lập KPI mặc định',
                                () => {
                                    DealerHelper.setDefaultKPI(
                                        agencyDetail,
                                        () => {
                                            handleGetKPIList();
                                            getAgencyDetail(agencyDetail?.agencyId);
                                        }
                                    );
                                },
                            )}
                    </div>
                )}
            </div>

            {/* body */}
            <div className="mt-4">
                <KTTable
                    columns={columns}
                    items={formattedSaleKPIList}
                    selectableRows={false}
                    striped={false}
                    compactGrid={false}
                    onClickedRow={() => { }}
                    onSelectedRowsChanged={(rows) => { }}
                    onDoubleClickedRow={(rows) => { }}
                    hasActionColumn={true}
                    groupHeader={true}
                    noDataComponent={
                        <EmptyView
                            icon={imgEmptyNhanVien}
                            title="Không có dữ liệu để hiển thị"
                            text={
                                <div className="text-center">
                                    <span>
                                        Hiện không có dữ liệu để hiển thị. Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.
                                    </span>
                                </div>
                            }
                        />
                    }
                />
            </div>

            {/* phan trang */}
            {!_.isEmpty(saleKPIList) && (
                <div className="mt-4">
                    <KTPagination
                        currentPage={filter.page + 1}
                        rowCount={saleKPITotal != 0 ? saleKPITotal : saleKPIList?.length}
                        rowsPerPage={filter.limit}
                        currentItemInPageCount={saleKPITotal}
                        onChangePage={(newPage) => {
                            const iNewPage = parseInt(newPage);
                            handleFilterChanged({
                                page: iNewPage - 1,
                            });
                        }}
                        onChangeRowsPerPage={(newRowsPerPage) => {
                            const iNewRowsPerPage = parseInt(newRowsPerPage);
                            handleFilterChanged({
                                limit: iNewRowsPerPage,
                                page: 0,
                            });
                        }}
                        loading={false}
                        color={KTPaginationColor.success}
                        appendText="giao dịch"
                    />
                </div>
            )}

        </div>
    );
}

export default SaleKPIListView;
